import { useTranslation } from 'react-i18next';

function RetryInstructions({ space = true }) {
  const { t } = useTranslation();
  return `${space ? ' ' : ''}${t(
    'Then try again by clicking the "Retry" button below.'
  )}`;
}

export default RetryInstructions;
